import React, { useEffect, useState } from "react"
import { userRequest } from "../../requestMethods"
import { Visibility } from "@material-ui/icons"
// Styles
import {
   Button,
   Container,
   Icon,
   Image,
   List,
   ListItem,
   StyledLink,
   Title,
   User,
   UserName,
   UserTitle,
} from "./WidgetSmall.styles"

const WidgetSmall = () => {
   const [users, setUsers] = useState([])

   useEffect(() => {
      const getUsers = async () => {
         try {
            const res = await userRequest.get("users/?new=true")
            setUsers(res.data)
         } catch (err) {
            setUsers(["No users to fetch", err])
         }
      }
      getUsers()
   }, [])

   return (
      <Container>
         <Title>New join members</Title>
         <List>
            {users?.map((user) => (
               <ListItem key={user._id}>
                  <Image
                     src={
                        user.img ||
                        "https://firebasestorage.googleapis.com/v0/b/lmwebsite-6ebd0.appspot.com/o/no_avatar.jpg?alt=media&token=c560d993-a555-4bf0-bb53-0f91f4d06e2f"
                     }
                  />
                  <User>
                     <UserName>{user.username}</UserName>
                     <UserTitle>{user.type}</UserTitle>
                  </User>
                  <Button>
                     <StyledLink to={`user/${user._id}`}>
                        <Icon>
                           <Visibility />
                        </Icon>
                        Display
                     </StyledLink>
                  </Button>
               </ListItem>
            ))}
         </List>
      </Container>
   )
}

export default WidgetSmall
